"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

function withRequired(Component) {
  return (
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(_class, _PureComponent);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return React.createElement(React.Fragment, null, React.createElement(Component, null), React.createElement("span", {
            style: {
              color: '#c9302c',
              paddingLeft: 3
            }
          }, "*"));
        }
      }]);

      return _class;
    }(PureComponent)
  );
}

function withColon(Component) {
  return (
    /*#__PURE__*/
    function (_PureComponent2) {
      _inherits(_class2, _PureComponent2);

      function _class2() {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }

      _createClass(_class2, [{
        key: "render",
        value: function render() {
          return React.createElement(React.Fragment, null, React.createElement(Component, null), React.createElement("span", null, ":"));
        }
      }]);

      return _class2;
    }(PureComponent)
  );
}

export default function withCaption(WrappedComponent) {
  var _class3, _temp;

  return _temp = _class3 =
  /*#__PURE__*/
  function (_PureComponent3) {
    _inherits(_class3, _PureComponent3);

    function _class3() {
      _classCallCheck(this, _class3);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
    }

    _createClass(_class3, [{
      key: "getCaption",
      value: function getCaption() {
        var _this$props$label = this.props.label,
            text = _this$props$label.text,
            visible = _this$props$label.visible,
            location = _this$props$label.location,
            showColon = _this$props$label.showColon;

        function Caption() {
          return React.createElement("span", null, text);
        }

        if (this.props.isRequired) {
          Caption = withRequired(Caption);
        }

        if (showColon) {
          Caption = withColon(Caption);
        } // return !visible ? null : <div className="dx-field-label" style={this.captionStyle(location)}>


        return !visible ? null : React.createElement("div", {
          style: this.captionStyle(location)
        }, React.createElement(Caption, null));
      }
    }, {
      key: "captionStyle",
      value: function captionStyle(location) {
        var style = {};

        if (['left', 'right'].includes(location)) {
          style.flexShrink = 0;
          style.alignSelf = 'center';
        } else {
          style.width = '100%';
        }

        if (location === 'right') {
          style.textAlign = 'right';
          style.paddingLeft = '3px';
        } else if (location === 'left') {
          style.paddingRight = '3px';
        }

        return style;
      }
    }, {
      key: "render",
      value: function render() {
        var location = this.props.label.location;
        var isVisible = this.props.isVisible;
        var topStyle = {
          display: isVisible ? 'flex' : 'none',
          flexDirection: this.getFlexDirection(location),
          alignItems: 'stretch'
        };
        return React.createElement("div", {
          className: "dx-field",
          style: topStyle
        }, this.getCaption(), React.createElement(WrappedComponent, this.props));
      }
    }, {
      key: "getFlexDirection",
      value: function getFlexDirection(location) {
        return location === 'top' ? 'column' : location === 'left' ? 'row' : 'row-reverse';
      }
    }]);

    return _class3;
  }(PureComponent), _defineProperty(_class3, "propTypes", {
    options: PropTypes.object.isRequired,
    itemType: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool,
    id: PropTypes.any.isRequired,
    label: PropTypes.object.isRequired
  }), _temp;
}